export default "__VITE_ASSET__jLI1uVLA__"